import { Badge } from "../ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export type GroupPostCategory = 'discussion' | 'announcement' | 'question' | 'event' | 'resource' | 'other';

interface GroupPostCategoriesProps {
  category: GroupPostCategory;
  tags: string[];
  onCategoryChange?: (category: GroupPostCategory) => void;
  isEditing?: boolean;
}

const categoryColors: Record<GroupPostCategory, string> = {
  discussion: "bg-blue-100 text-blue-800",
  announcement: "bg-purple-100 text-purple-800",
  question: "bg-yellow-100 text-yellow-800",
  event: "bg-green-100 text-green-800",
  resource: "bg-indigo-100 text-indigo-800",
  other: "bg-gray-100 text-gray-800"
};

const categoryLabels: Record<GroupPostCategory, string> = {
  discussion: "Discussion",
  announcement: "Announcement",
  question: "Question",
  event: "Event",
  resource: "Resource",
  other: "Other"
};

export const GroupPostCategories = ({ 
  category, 
  tags, 
  onCategoryChange,
  isEditing = false 
}: GroupPostCategoriesProps) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {isEditing ? (
        <Select
          value={category}
          onValueChange={(value) => onCategoryChange?.(value as GroupPostCategory)}
        >
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Select category" />
          </SelectTrigger>
          <SelectContent>
            {Object.entries(categoryLabels).map(([value, label]) => (
              <SelectItem key={value} value={value}>
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        <Badge className={categoryColors[category]}>
          {categoryLabels[category]}
        </Badge>
      )}
      
      {tags.map((tag) => (
        <Badge key={tag} variant="outline">
          {tag}
        </Badge>
      ))}
    </div>
  );
};